import { FunctionComponent, h } from 'preact';
import { Desktop, MobileAndTablet } from '../../../responsive-devices/responsive-devices';
import TrackingMap from '../tracking-map/tracking-map';
import TrackingDriverCard from '../tacking-driver-card/tracking-driver-card';
import SharedLocationLayout from '../../../pages/shared-location-layout/shared-location-layout';
import TrackingStatusBar from '../tracking-status-bar/tracking-status-bar';
import { useStore } from '../../../helpers/use-store';
import { useEffect } from 'preact/hooks';
import { observer } from 'mobx-react';
import { isNil as _isNil } from 'lodash';

const TrackingPanel: FunctionComponent = observer(() => {
	const { driverTrackingStore } = useStore();
	const {
		customerExperience: {
			hide_footer: hideDriverFooter,
			show_delivery_status: showTrackingStatusBar,
			numberOfTasksLeftInRun
		},
		trackingStatus,
		wayPointArrived
	} = driverTrackingStore;

	useEffect(() => {
		return () => driverTrackingStore.dispose();
	}, []);

	const showStatusBar = showTrackingStatusBar && !_isNil(trackingStatus);

	return (
		<SharedLocationLayout
			className="tracking-panel"
			footerClassName="tracking-panel-powered-by-footer"
			dataTestId="tracking-panel"
		>
			<MobileAndTablet>
				{showStatusBar && !wayPointArrived && (
					<TrackingStatusBar
						trackingStatus={trackingStatus}
						numberOfTasksLeftInRun={numberOfTasksLeftInRun}
					/>
				)}
				<TrackingMap />
				{!hideDriverFooter && (
					<div className="tracking-panel-mobile-driver-footer">
						<TrackingDriverCard />
					</div>
				)}
			</MobileAndTablet>

			<Desktop>
				{!hideDriverFooter && <TrackingDriverCard />}
				{showStatusBar && (
					<TrackingStatusBar
						trackingStatus={trackingStatus}
						numberOfTasksLeftInRun={numberOfTasksLeftInRun}
					/>
				)}
			</Desktop>
		</SharedLocationLayout>
	);
});

export default TrackingPanel;
